export class TableDataQualityPartitionRow {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "labels",
            "baseName": "labels",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "records",
            "baseName": "records",
            "type": "number",
            "format": "double"
        },
        {
            "name": "lastCommitMs",
            "baseName": "lastCommitMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "freshnessSeconds",
            "baseName": "freshnessSeconds",
            "type": "number",
            "format": "double"
        },
        {
            "name": "maxNullRate",
            "baseName": "maxNullRate",
            "type": "number",
            "format": "double"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "HealthStatus",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableDataQualityPartitionRow.attributeTypeMap;
    }
    constructor() {
    }
}
